import { generateNewBoid } from "./Boid.js";

export const pointDistance = (p1, p2) => {
  return Math.sqrt(
    Math.pow(Math.abs(p1.x - p2.x), 2) + Math.pow(Math.abs(p1.y - p2.y), 2)
  );
};

export const calcAlignmentHeading = neighbors => {
  if (!neighbors || neighbors.length <= 0) {
    return null;
  }

  // average the headings as a circular quantity (sum the unit vectors, then
  // atan2) so angles that straddle the +/-PI wrap don't bias toward 0 (right)
  const sumSin = neighbors.reduce((s, n) => s + Math.sin(n.heading), 0);
  const sumCos = neighbors.reduce((s, n) => s + Math.cos(n.heading), 0);

  return Math.atan2(sumSin, sumCos);
};

export const calcCohesionHeading = (boid, neighbors) => {
  if (!neighbors || neighbors.length <= 0) {
    return null;
  }

  let avgPosition = neighbors.reduce((accumulator, neighbor) => {
    return { x: accumulator.x + neighbor.x, y: accumulator.y + neighbor.y };
  });

  avgPosition = {
    x: avgPosition.x / neighbors.length,
    y: avgPosition.y / neighbors.length
  };

  return Math.atan2(avgPosition.y - boid.y, avgPosition.x - boid.x);
};

export const calcSeparationHeading = (boid, neighbors, separationRadius) => {
  //const separationRadius = 15; //0,10,20,30,40
  if (!neighbors || neighbors.length <= 0) {
    return null;
  }
  // only separate from really close neighbors,
  // i.e. those that are within 2x radius of the boid

  const closeNeighbors = neighbors.filter(neighbor => {
    return pointDistance(boid, neighbor) < separationRadius;
  });

  if (closeNeighbors.length <= 0) {
    return null;
  }

  // get avg angle of close neighbors
  let avgPosition = closeNeighbors.reduce((accumulator, closeNeighbor) => {
    return {
      x: accumulator.x + closeNeighbor.x,
      y: accumulator.y + closeNeighbor.y
    };
  });

  avgPosition = {
    x: avgPosition.x / closeNeighbors.length,
    y: avgPosition.y / closeNeighbors.length
  };

  let heading =
    Math.atan2(avgPosition.y - boid.y, avgPosition.x - boid.x) + Math.PI;
  //make sure heading is between -Math.PI <= heading <= Math.PI
  heading = heading > Math.PI ? heading - 2 * Math.PI : heading;
  heading = heading < -Math.PI ? heading + 2 * Math.PI : heading;
  return heading;
};

export const getBoidSpeed = () => {
  const max = 8;
  const min = 5;
  return Math.floor(Math.random() * (max - min + 1) + min);
};

export const BUNCH_SIZE = 100;

export const createBunch = (
  bunchNumber,
  isolationFactor,
  canvasWidth,
  canvasHeight
) => {
  let newBoids = [];
  const isoFactor = isolationFactor / 100;

  for (let i = 0; i < bunchNumber; i++) {
    newBoids.push({
      ...generateNewBoid(),
      x: Math.random() * canvasWidth,
      y: Math.random() * canvasHeight,
      speed: Math.random() < isoFactor ? 0 : getBoidSpeed()
    });
  }
  return newBoids;
};

export const infectRandomBoid = boids => {
  const mobileAndHealthyBoids = boids.filter(
    b => b.speed > 0 && b.state === "normal"
  );
  const rndmIdx = Math.floor(Math.random() * mobileAndHealthyBoids.length);
  const boidToInfect = mobileAndHealthyBoids[rndmIdx];
  return boids.map(boid => {
    if (boidToInfect && boid.id === boidToInfect.id) {
      return {
        ...boid,
        state: "infected",
        infectedTime: Date.now()
      };
    }
    return boid;
  });
};
